import { Component, Input, OnInit } from '@angular/core';

import { RippleModule } from 'primeng/ripple';
import { ButtonModule } from 'primeng/button';
import { RouterLink } from '@angular/router';
import {
  Discount,
  Manufacturer
} from '../../../../graphql/generated/generated-types';
import { Router } from '@angular/router';
import { StateService } from '../../../../core/state/old/state.service';
import { AssetPreviewPipe } from '../../../pipes/asset-preview.pipe';
import { ChipModule } from 'primeng/chip';
import { TooltipModule } from 'primeng/tooltip';
import { VehicleTypeService } from '../../../services/vehicle-type.service';
import { SelectedModificationService } from '../../../services/selected-modification.service';
@Component({
  selector: 'app-product-details-header',
  standalone: true,
  imports: [
    RippleModule,
    ButtonModule,
    RouterLink,
    AssetPreviewPipe,
    ChipModule,
    TooltipModule
  ],
  templateUrl: './product-details-header.component.html',
  styleUrl: './product-details-header.component.scss',
})
export class ProductDetailsHeaderComponent implements OnInit {

  @Input() name: string;
  @Input() slug: string;
  @Input() manufacturer!: Manufacturer;
  @Input() sku!: string;
  @Input() discounts!: Discount[];
  @Input() stockLevel!: number;
  @Input() quantity!: boolean;


  @Input() brandAndNameInline!: boolean;
  @Input() showCodeAndBrandLine: boolean = true;
  @Input() showLabels!: boolean;
  @Input() inCart!: boolean;
  @Input() small: boolean = false;
  @Input() medium: boolean = false;


  @Input() studdedTires: boolean
  @Input() studdableTires: boolean;

  constructor(public router: Router, private stateService: StateService,
    public vehicleTypeService: VehicleTypeService,
    public selectedModificationService: SelectedModificationService) 
   { }

  ngOnInit(): void { }

  public closeCartSidebar() {
    this.stateService.setState('cartSidebarVisible', false);
  }
}
